module.exports = __webpack_public_path__ + "img/openapptitle.a6c9bd35.png";